import {StyleSheet, View} from "react-native";
import React from "react";
import {JobRowDetail} from "./index";
import commonStyles from "../styles";
import shallowEqual from 'shallowequal';

interface IJobRowAsHeaderProps {
    workshopJobRow: any;
    actionContent?: JSX.Element;
    showActionContent?: boolean;
    disableBottomRadius?: boolean;
}

const JobRowAsHeader = (props: IJobRowAsHeaderProps) => {
    const {workshopJobRow, disableBottomRadius, showActionContent} = props;
    return <View style={[commonStyles.cardOne, disableBottomRadius ? {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0
    } : null]}>
        <View style={[styles.row]}>
            <View style={{minWidth: '50%', marginLeft: 5}}>
                <JobRowDetail jobRow={workshopJobRow.jobRow}/>
            </View>
            {
                showActionContent ? <View style={{
                    flexDirection: "row",
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    flex: 1
                }}>
                    {props.actionContent}
                </View> : null
            }
        </View>
    </View>;
};

const areEqual = function areEqual(prevProps, nextProps) {
    return JSON.stringify({...prevProps, actionContent: null}) === JSON.stringify({...nextProps, actionContent: null}) && shallowEqual(prevProps.actionContent, nextProps.actionContent)
};

export default React.memo(JobRowAsHeader, areEqual);

const styles = StyleSheet.create({
    row: {
        flex: 1,
        flexDirection: 'row'
    }
})